import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

declare interface RouteInfo {
  text1?: string;
  text2?: string;
  text3?: string;
  listTitle?: string;
  list1?: string;
  list2?: string;
  list3?: string;
  list4?: string;
  list5?: string;
  list6?: string;
  img?: string;
  alt?: string;
  href?: string;
}
export const AnnualConventionContent: RouteInfo[] = [
  {
    text1:
      'The CHCC strives to develop long-term commitments and engagement with our Corporate Partners and members. The mission of the CHCC Partnership and Membership Program (CPMP) is to create and continuously promote the growth of Hispanic and diverse businesses and communities for the common benefit of our members and corporate partners.',
    text2:
      "The CHCC's CPMP provides our corporate partners with a platform and leadership opportunity to get involved with the CHCC through our Corporate Council (CCC) and our Procurement, Diversity, and Inclusion Council (PDIC). Through these two councils, corporate partners have the opportunity to advise CHCC leadership on industry-specific concerns and provide insight, as well as share industry and company-specific legislative challenges to help shape and inform the CHCC's Policy Platform. In addition, you will have the opportunity to support the growth of businesses of all sizes in the Hispanic and diverse communities by advising on the scope and approach that CHCC programs utilize to strengthen local chambers and Hispanic and diverse companies. You will also encourage the participation of supplier diversity professionals in award nominations, matchmaking sessions, and other CHCC opportunities.",
    text3:
      'I look forward to discussing with you further the opportunities that exist through the CHCC’s Corporate Partnership and Membership program.',
    listTitle:
      'The Benefits of Working with the CHCC and the Hispanic Business Community',
    list1:
      "Small business is the backbone of California's economy – 97% of all businesses in California are small businesses.",
    list2: 'There are over 815,000 Hispanic-owned businesses in California.',
    list3:
      'Hispanic businesses in California generate over $200 billion in annual revenue.',
    list4:
      'Hispanics are the largest minority in California, making up 40% of the current population.',
    list5:
      "The purchasing power of California's Hispanic community is currently over $500 billion.",
    list6:
      "Hispanic-owned businesses are the future of California's economy, growing three times the national average compared to the general market. Women within this segment are starting new enterprises at five times the rate of their male counterparts.",
  },
];
export const SecondBullets: RouteInfo[] = [
  {
    listTitle: 'Highlights of the CHCC Corporate and Membership Program',
    list1:
      "Join the organization that represents the nation's fastest-growing sector of the business community.",
    list2:
      'Collaborate with your corporate peers to help shape the CHCC in policy and supplier development.',
    list3:
      'Build your network and brand through our annual events; The California Business Policy Summit, The CHCC Statewide Convention, and the CHCC Legislative and Economic Forecast.',
    list4:
      'Grow the economic prospects for small businesses and the Hispanic business community by providing corporate support and development.',
  },
];

export const First: RouteInfo[] = [
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/Amazon.png',
    alt: 'Amazon Business Logo',
    href: 'https://www.aboutamazon.com/',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/Bank of America Logo.png',
    alt: 'Bank Of America Business Logo',
    href: 'https://about.bankofamerica.com/en/our-company',
  },
  {
    img: '../../../assets/images/corporateMember/CalWater Logo.png',
    alt: 'Cal Water Business Logo',
    href: 'https://www.calwater.com/',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/CVS .png',
    alt: 'CVS Health Business Logo',
    href: 'https://www.cvshealth.com/about-cvs-health',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/jpmc-logo.png',
    alt: 'J.P. Morgan Chase Business Logo',
    href: 'https://www.jpmorganchase.com/',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/meta-logo.png',
    alt: 'Meta Business Logo',
    href: 'https://about.meta.com/?utm_source=about.facebook.com&utm_medium=redirect',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/ PG&E.png',
    alt: 'PG&E  Business Logo',
    href: 'https://www.pge.com/en_US/about-pge/about-pge.page',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/southernCAEdison.png',
    alt: 'Southern CA Edison Business Logo',
    href: 'https://www.sce.com/',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/Tmobile.png',
    alt: 'T-Mobile Business Logo',
    href: 'https://www.t-mobile.com/about-us',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/weedmaps.png',
    alt: 'Weedmaps Business Logo',
    href: 'https://weedmaps.com/',
  },
];

export const Partner: RouteInfo[] = [
  {
    img: '../../../assets/images/corporateMember/cocoCola.png',
    alt: 'Coca-Cola Company Business Logo',
    href: 'https://www.coca-colacompany.com/company',
  },

  {
    img: '../../../assets/images/corporatePartnerLogo/charter-logo.png',
    alt: 'Charter Communication Business Logo',
    href: 'https://corporate.charter.com/',
  },
  {
    img: '../../../assets/images/corporatePartnerLogo/lowes-blue-logo.png',
    alt: 'Lowes Business Logo',
    href: 'https://corporate.lowes.com/who-we-are',
  },
  {
    img: '../../../assets/images/corporatePartnerLogo/ParkwestCasino.png',
    alt: 'Parkwest Casinos Business Logo',
    href: 'http://www.fortiss.com/',
  },
  {
    img: '../../../assets/images/corporatePartnerLogo/Turo_Logo.png',
    alt: 'Turo Business Logo',
    href: 'https://turo.com/',
  },
  {
    img: '../../../assets/images/corporatePartnerLogo/WSPA.png',
    alt: 'WSPA Business Logo',
    href: 'https://www.wspa.org/',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/wellsFargo.png',
    alt: 'Wells Fargo Business Logo',
    href: 'https://www.wellsfargo.com/',
  },
];

export const Members: RouteInfo[] = [
  {
    img: '../../../assets/images/corporatePartnerLogo/CA Strawberry Commission Logo.jpg',
    alt: 'CA Strawberry Commission Business Logo',
    href: 'https://login.calstrawberry.com/landing',
  },
  {
    img: '../../../assets/images/corporateMember/Alaska.jpg',
    alt: 'Alaska Air Business Logo',
    href: 'https://www.alaskaair.com/content/about-us',
  },
  {
    img: '../../../assets/images/corporateMember/americanBeverage.png',
    alt: 'American Beverage Business Logo',
    href: 'https://www.americanbeverage.org/',
  },
  {
    img: '../../../assets/images/corporateMember/AT&T.jpg',
    alt: 'AT&T Business Logo',
    href: 'https://about.att.com/pages/corporate-profile',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/cwa.png',
    alt: 'California Water Association Business Logo',
    href: 'https://calwaterassn.com/',
  },

  {
    img: '../../../assets/images/corporateMember/ComericaLogo.png',
    alt: 'Comerica Business Logo',
    href: 'https://www.comerica.com/about-us/company-overview.html#:~:text=Comerica%20Incorporated%20is%20a%20financial%2cRetail%20Bank%2c%20and%20Wealth%20Management.&text=The%20Senior%20Leadership%20Team%20is%20comprised%20of%20senior%20officers%20of%20the%20corporation.',
  },
  {
    img: '../../../assets/images/corporateMember/costaRicaForeign.png',
    alt: 'Essential Costa Rica Business Logo',
    href: 'https://www.esencialcostarica.com/eng/',
  },
  {
    img: '../../../assets/images/corporateMember/DoorDash Stacked Logo.jpg',
    alt: 'Door Dash Business Logo',
    href: 'https://www.doordash.com/en-US/about/',
  },
  {
    img: '../../../assets/images/corporateMember/eaze.png',
    alt: 'Eaze Business Logo',
    href: 'https://www.eaze.com/',
  },
  {
    img: '../../../assets/images/corporateMember/fiserv.png',
    alt: 'Fiserv Business Logo',
    href: 'https://www.fiserv.com/en.html',
  },
  {
    img: '../../../assets/images/corporateMember/Apex Group.jpg',
    alt: 'The Apex Group Business Logo',
    href: 'https://www.theapexgroup.net/',
  },
  {
    img: '../../../assets/images/corporateMember/instaCart.png',
    alt: 'Insta Cart Business Logo',
    href: 'https://www.instacart.com/',
  },
  {
    img: '../../../assets/images/corporateMember/Latino Times.png',
    alt: 'Latino Times Business Logo',
    href: 'https://www.latinotimes.org/',
  },
  {
    img: '../../../assets/images/corporateMember/Lyft Logo.png',
    alt: 'Lyft Business Logo',
    href: 'https://www.lyft.com/',
  },
  {
    img: '../../../assets/images/corporateMember/nuemillerBeardslee.png',
    alt: 'Neumiller Business Logo',
    href: 'https://www.neumiller.com/about-us/',
  },
  {
    img: '../../../assets/images/corporateMember/Pepsico .png',
    alt: 'Pepsico Business Logo',
    href: 'https://www.pepsico.com/',
  },
  {
    img: '../../../assets/images/corporateMember/Sempra.png',
    alt: 'Sempra Business Logo',
    href: 'https://www.sempra.com/about',
  },
  {
    img: '../../../assets/images/corporateMember/Siemens.png',
    alt: 'Siemens Business Logo',
    href: 'https://www.siemens.com/us/en.html?gclid=Cj0KCQjwsrWZBhC4ARIsAGGUJupFPflLJ5Vy8N5fRzmQ85Hu88eBjSKwIm1Y8ESAd1M95E3p-CZW2voaAqYwEALw_wcB&acz=1',
  },
  {
    img: '../../../assets/images/corporateMember/Smithfield.png',
    alt: 'Smith Field Business Logo',
    href: 'https://www.smithfieldfoods.com/',
  },
  {
    img: '../../../assets/images/corporateMember/telacu.png',
    alt: 'Telacu Business Logo',
    href: 'https://telacu.com/',
  },
  {
    img: '../../../assets/images/corporateMember/Union Bank_Logo_Large_CMYK.jpg',
    alt: 'Union Bank Business Logo',
    href: 'https://www.unionbank.com/',
  },
];
@Component({
    selector: 'app-corporate-membership',
    templateUrl: './corporate-membership.component.html',
    styleUrls: ['./corporate-membership.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CorporateMembershipComponent implements OnInit {
  mainTitle = 'Corporate Membership';
  texts: any = [];
  secondLists: any = [];
  firsts: any = [];
  partners: any = [];
  members: any = [];

  constructor() {}

  ngOnInit(): void {
    this.texts = AnnualConventionContent.filter((text) => text);
    this.secondLists = SecondBullets.filter((secondList) => secondList);
    this.firsts = First.filter((first) => first);
    this.partners = Partner.filter((partner) => partner);
    this.members = Members.filter((member) => member);
  }
}
